<template>
  <div class="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
    <h2 class="mb-6 text-xl font-semibold text-slate-900">
      Hiring Steps
    </h2>
    <div class="space-y-6">
      <div v-for="(description, step, index) in hiringSteps" :key="index" class="relative flex gap-4">
        <div class="flex-shrink-0">
          <div class="flex h-10 w-10 items-center justify-center rounded-full text-white font-semibold"
            :style="{ backgroundColor: brandColor }">
            {{ getStepNumber(step, index) }}
          </div>
        </div>
        <div class="flex-1 pt-1">
          <h3 class="mb-2 text-lg font-semibold text-slate-900">
            {{ getStepTitle(step) }}
          </h3>
          <p class="text-slate-700 leading-relaxed">
            {{ description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
interface Props {
  hiringSteps: Record<string, string>
  brandColor: string
  companyName: string
}
const props = defineProps<Props>()
function getStepNumber(step: string, index: number): number {
  const match = step.match(/^(\d+)\./)
  if (match) {
    return parseInt(match[1])
  }
  return index + 1
}
function getStepTitle(step: string): string {
  return step.replace(/^\d+\.\s*/, '')
}
</script>